<div class="header go-to-active" data-automation-id="topics-header">
  <h3 translate>contents.topics_tip</h3>
</div>

<div *ngIf="(isTopicsTreeEmpty$ | async) || (errorLoadingSubjects$ | async) || (isHydrationLoading$ | async)">
  <div
    class="topic-alert"
    *ngIf="errorLoadingSubjects$ | async; else loadingTopics"
  >
    <mhe-alert
      id="main-topics-tree-error"
      [smallAlert]="true"
      [type]="AlertType.Error"
      [closable]="false"
      data-automation-id="topics-subjects-alert"
    >
      {{ "contents.topics_menu_alert" | translate }}
    </mhe-alert>
  </div>
  <ng-template #loadingTopics>
    <mat-progress-spinner
      class="rdrx-spinner spine-annotations-loading"
      mode="indeterminate"
      id="main-topics-tree-loading"
      data-automation-id="topics-subjects-loading"
      style="margin-top: 1rem"
      [strokeWidth]="2"
      [diameter]="75"
    ></mat-progress-spinner>
  </ng-template>
</div>

<ng-container *ngIf="(isHydrationLoading$ | async) === false">
  <ng-container
    *ngIf="
      materialFA4TopicsToggle$ | async;
      then newMaterialPanel;
      else oldBonsaiTree
    "
  >
  </ng-container>
</ng-container>

<ng-template #newMaterialPanel>
  <ng-container *ngIf="isLocationsView$ | async; else materialMainSubjectList">
    <div
      class="material-locations-header"
      tabindex="0"
      (click)="hideMaterialLocationsView()"
      (keydown.Enter)="hideMaterialLocationsView()"
      (keydown.Space)="hideMaterialLocationsView()"
      [attr.aria-label]="
        ('contents.topics_back_to' | translate) +
        (locationsView$ | async)?.currentSubjectNode?.title
      "
      data-automation-id="material-subjectBacklink"
    >
      <i class="dpg-icon dpg-icon-system-left-arrow material-back-arrow" data-automation-id="material-back-arrow"></i>
      <div class="material-header-content">
        <h5 class="material-subject-title" data-automation-id="material-subject-title">
          {{ (locationsView$ | async)?.currentSubjectNode?.title }}
        </h5>
        <h5 class="material-topic-title" data-automation-id="material-topic-title">
          {{ (locationsView$ | async)?.currentTopicNode?.title }}
        </h5>
      </div>
    </div>

    <div class="topic-alert" *ngIf="showTopicDetailsError">
      <mhe-alert
        [smallAlert]="true"
        [type]="AlertType.Error"
        [closable]="false"
        data-automation-id="material-topics-details-alert"
      >
        {{ "contents.topics_menu_alert" | translate }}
      </mhe-alert>
    </div>

    <mat-accordion
      *ngIf="materialLocationsView$ | async as locationsViewData"
      multi
      hideToggle
      class="material-locations-accordion"
      data-automation-id="material-locations-accordion"
    >
      <!-- Locations List -->
      <div
        class="material-locations-content"
        data-automation-id="material-locations-content"
        *ngIf="locationsViewData.materialLocations?.length"
      >
        <div
          *ngFor="
            let location of locationsViewData.materialLocations;
            trackBy: trackById
          "
          class="material-location-item"
          data-automation-id="material-location-item"
        >
          <a
            href="javascript:void(0)"
            class="material-location-link ahe-ui-link"
            data-automation-id="material-location-link"
            [rdrxTopicsActiveNode]="location.id === (activeLocationId$ | async)"
            (click)="handleNodeClick(location)"
            (keydown.Space)="$event.preventDefault(); handleNodeClick(location)"
          >
            {{ location.title }}
          </a>
        </div>
      </div>

      <!-- Case‐Patterns Panels -->
      <mat-expansion-panel
        *ngFor="
          let section of locationsViewData.materialCasesPatterns;
          trackBy: trackById
        "
        class="material-cases-patterns-panel"
        data-automation-id="material-cases-patterns-panel"
        [expanded]="
          (locationsView$ | async)?.expandedCasesPatterns?.[section.id]
        "
        (opened)="toggleExpandedLocations(section.id)"
        (closed)="toggleExpandedLocations(section.id)"
      >
        <mat-expansion-panel-header class="material-cases-patterns-header" data-automation-id="topics-cases-patterns-header">
          <div
            class="topics-expand-icon"
            data-automation-id="topics-expand-icon"
            [class.expanded]="
              (locationsView$ | async)?.expandedCasesPatterns?.[section.id]
            "
          ></div>
          <span class="vertical-divider"></span>
          <div class="mat-content">
            <mat-panel-title data-automation-id="topics-panel-title">
              {{ section.title }}
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>

        <div class="material-cases-patterns-content" data-automation-id="material-cases-patterns-content">
          <div
            *ngFor="
              let item of section.items;
              trackBy: trackById
            "
            class="material-case-pattern-item"
            data-automation-id="material-case-pattern-item"
          >
            <a
              href="javascript:void(0)"
              class="material-case-pattern-link ahe-ui-link"
              data-automation-id="material-case-pattern-link"
              (click)="handleNodeClick(item)"
              (keydown.Space)="$event.preventDefault(); handleNodeClick(item)"
            >
              {{ item.title }}
            </a>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Boards & Beyond Panel -->
      <mat-expansion-panel
        *ngIf="locationsViewData.materialBbVideos?.length"
        class="material-bb-videos-panel"
        data-automation-id="material-bb-videos-panel"
        [expanded]="
          (locationsView$ | async)?.expandedCasesPatterns?.['bb-videos']
        "
        (opened)="toggleExpandedLocations('bb-videos')"
        (closed)="toggleExpandedLocations('bb-videos')"
      >
        <mat-expansion-panel-header class="material-bb-videos-header" data-automation-id="topics-bb-videos-header">
          <div
            class="topics-expand-icon"
            data-automation-id="topics-expand-icon"
            [class.expanded]="
              (locationsView$ | async)?.expandedCasesPatterns?.['bb-videos']
            "
          ></div>
          <span class="vertical-divider"></span>
          <div class="mat-content">
            <mat-panel-title class="material-bb-title" data-automation-id="topics-panel-title">
              <img
                class="material-bb-logo"
                data-automation-id="material-bb-logo"
                src="/assets/images/b&b/b&b_bg_svg.svg"
                alt="Boards & Beyond Product Logo"
              />
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>

        <div class="material-bb-videos-content" data-automation-id="material-bb-videos-content">
          <div
            *ngFor="
              let video of locationsViewData.materialBbVideos;
              trackBy: trackById
            "
            class="material-bb-video-item"
            data-automation-id="material-bb-video-item"
          >
            <a
              href="javascript:void(0)"
              class="material-bb-video-link ahe-ui-link"
              data-automation-id="material-bb-video-link"
              (click)="handleNodeClick(video, true)"
              (keydown.Space)="$event.preventDefault(); handleNodeClick(video, true)"
            >
              <img src="/assets/icons/b&b/play.svg" alt="Play Icon" />
              <span>&nbsp;</span>
              Video: {{ video.title }}
            </a>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>

  <ng-template #materialMainSubjectList>
    <mat-accordion
      *ngIf="(materialExpansionSubjects$ | async)?.length > 0"
      multi
      class="material-topics-accordion"
      data-automation-id="material-subject-list"
    >
      <mat-expansion-panel
        #panel="matExpansionPanel"
        *ngFor="
          let subject of materialExpansionSubjects$ | async;
          trackBy: trackById
        "
        class="material-topics-panel"
        data-automation-id="material-topics-panel"
        [expanded]="(materialExpandedPanels$ | async)?.[subject.id]"
        (expandedChange)="onPanelStateChange($event, subject)"
      >
        <mat-expansion-panel-header class="material-topics-header" data-automation-id="topics-material-subject-header">
          <div class="topics-expand-icon" data-automation-id="topics-expand-icon" [class.expanded]="panel.expanded"></div>
          <span class="vertical-divider"></span>
          <div class="mat-content">
            <mat-panel-title data-automation-id="topics-panel-title">
              {{ subject.title }}
            </mat-panel-title>
            <button
              data-automation-id="topics-material-practice-button"
              *ngIf="
                subject.type === 'TOPIC_CATEGORY' && subject.assessments?.length
              "
              mheStopPropagation
              class="btn btn-secondary"
              (click)="handleNodeClick(subject)"
              (keydown.Enter)="$event.preventDefault(); $event.stopPropagation(); handleNodeClick(subject)"
              (keydown.Space)="$event.preventDefault(); $event.stopPropagation(); handleNodeClick(subject)"
              translate
            >
              contents.topics_practice
            </button>
          </div>
        </mat-expansion-panel-header>

        <div class="material-topics-content" data-automation-id="material-topics-content">
          <ng-container *ngIf="!subject.loading; else loadingTopicsSpinner">
            <div
              *ngFor="let topic of subject.topics; trackBy: trackById"
              class="material-topic-item"
              data-automation-id="material-topic-item"
            >
              <a
                href="javascript:void(0)"
                class="material-topic-link ahe-ui-link"
                data-automation-id="material-topic-link"
                [rdrxTopicsActiveNode]="topic.id === (activeTopicId$ | async)"
                (click)="showMaterialLocationsView(topic)"
                (keydown.Space)="$event.preventDefault(); showMaterialLocationsView(topic)"
                tabindex="0"
              >
                {{ topic.title }}
              </a>
            </div>
          </ng-container>
          <ng-template #loadingTopicsSpinner>
            <mat-progress-spinner
              class="rdrx-spinner material-topics-loading"
              data-automation-id="material-topics-loading"
              mode="indeterminate"
              [strokeWidth]="2"
              [diameter]="75"
            ></mat-progress-spinner>
          </ng-template>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-template>
</ng-template>

<ng-template #oldBonsaiTree>
  <ng-container *ngIf="isLocationsView$ | async; else bonsaiMainSubjectList">
    <a
      [attr.aria-label]="
        ('contents.topics_back_to' | translate) +
        (locationsView$ | async)?.currentSubjectNode?.title
      "
      class="header"
      tabindex="0"
      (click)="hideLocationsView()"
      (keydown.Enter)="hideLocationsView()"
      (keydown.Space)="hideLocationsView()"
      data-automation-id="subjectBacklink"
    >
      <i class="dpg-icon dpg-icon-system-left-arrow"></i>
      <div class="header-back">
        <h4 class="header-back_subject">
          {{ (locationsView$ | async)?.currentSubjectNode?.title }}
        </h4>
        <h5 class="header-back_topic">
          {{ (locationsView$ | async)?.currentTopicNode?.title }}
        </h5>
      </div>
    </a>
    <div class="topic-alert" *ngIf="showTopicDetailsError">
      <mhe-alert
        id="locations-topics-tree-error"
        [smallAlert]="true"
        [type]="AlertType.Error"
        [closable]="false"
        data-automation-id="topics-details-alert"
      >
        {{ "contents.topics_menu_alert" | translate }}
      </mhe-alert>
    </div>
    <ngx-bonsai
      rdrxBonsaiTabIndex
      class="rdrx locations-view"
      [nodesById]="(locationsView$ | async)?.locationsTree"
      data-automation-id="locations-tree-group"
      [rootNodeId]="rootNodeId"
      [expandedNodes]="{}"
    >
      <ng-template #treeNodeTemplate let-node>
        <a
          attr.aria-haspopup
          mheStopPropagation
          rdrxBonsaiNodeSelect
          href="javascript:void(0)"
          class="location-tree-elem rdrx-node-content ahe-ui-link"
          [attr.data-automation-id]="'topics-location-child-' + node.id"
          tabindex="-1"
          [rdrxBonsaiNodeSelectKeyboard]="!node.collapsible"
          [rdrxTopicsActiveNode]="node.id === (activeLocationId$ | async)"
          (click)="handleNodeClick(node)"
        >
          {{ node.title }}
        </a>
      </ng-template>
    </ngx-bonsai>
    <div id="locations-view-bonsai-wrapper">
      <ngx-bonsai
        rdrxBonsaiTabIndex
        class="rdrx locations-view"
        [nodesById]="(locationsView$ | async)?.casesPatternsTree"
        data-automation-id="cases-patterns-tree-group"
        [rootNodeId]="rootNodeId"
        [expandedNodes]="(locationsView$ | async)?.expandedCasesPatterns"
        [showToggleFn]="showToggleFn"
        (expanderClick)="toggleExpandedLocations($event)"
      >
        <ng-template #treeNodeTemplate let-nodeLocation>
          <a
            attr.aria-haspopup
            mheStopPropagation
            rdrxBonsaiNodeSelect
            href="javascript:void(0)"
            class="location-cases-patterns-tree-elem rdrx-node-content ahe-ui-link"
            [attr.data-automation-id]="
              'topics-cases-patterns-child-' + nodeLocation.id
            "
            tabindex="-1"
            [rdrxBonsaiNodeSelectKeyboard]="!nodeLocation.collapsible"
            (click)="handleNodeClick(nodeLocation)"
            [ngClass]="{
              'locations-header': nodeLocation.type === 'HEADER',
              'topic-locations-header': nodeLocation.id === 'TOPICS',
              'topic-location': nodeLocation.parent === 'TOPICS'
            }"
          >
            {{ nodeLocation.title }}
          </a>
        </ng-template>
      </ngx-bonsai>
    </div>

    <div id="bb-view-bonsai-wrapper" *ngIf="haveBbVideos">
      <ngx-bonsai
        rdrxBonsaiTabIndex
        class="rdrx locations-view"
        [nodesById]="bbVideos"
        data-automation-id="boards-and-beyond-tree-group"
        [rootNodeId]="rootNodeId"
        [expandedNodes]="(locationsView$ | async)?.expandedCasesPatterns"
        [showToggleFn]="showToggleFn"
        (expanderClick)="toggleExpandedLocations($event)"
      >
        <ng-template #treeNodeTemplate let-nodeLocation>
          <a
            attr.aria-haspopup
            mheStopPropagation
            rdrxBonsaiNodeSelect
            href="javascript:void(0)"
            class="location-cases-patterns-tree-elem rdrx-node-content ahe-ui-link bb_video"
            [attr.data-automation-id]="
              'topics-cases-patterns-child-' + nodeLocation.id
            "
            tabindex="-1"
            [rdrxBonsaiNodeSelectKeyboard]="!nodeLocation.collapsible"
            (click)="handleNodeClick(nodeLocation, true)"
          >
            <figure *ngIf="nodeLocation.header; else elseBlock">
              <img
                class="bb-view-bonsai-wrapper__logo"
                src="/assets/images/b&b/b&b_bg_svg.svg"
                alt="Boards & Beyond Product Logo"
              />
            </figure>
            <ng-template #elseBlock>
              <img src="/assets/icons/b&b/play.svg" alt="Play Icon" />
              <span>&nbsp;</span>
              Video: {{ nodeLocation.title }}
            </ng-template>
          </a>
        </ng-template>
      </ngx-bonsai>
    </div>
  </ng-container>

  <ng-template #bonsaiMainSubjectList>
    <ngx-bonsai
      rdrxBonsaiTabIndex
      class="rdrx"
      data-automation-id="subject-list"
      [nodesById]="topicsTree$ | async"
      [rootNodeId]="rootNodeId"
      [expandedNodes]="expandedSubjects$ | async"
      (expanderClick)="toggleExpandedSubjects($event)"
      [isLoading]="isLoading"
      [showToggleFn]="showToggleFn"
    >
      <ng-template #loadingTemplate>
        <mat-progress-spinner
          class="rdrx-spinner spine-annotations-loading"
          data-automation-id="topics-tree-loading"
          mode="indeterminate"
          [strokeWidth]="2"
          [diameter]="75"
        ></mat-progress-spinner>
      </ng-template>
      <ng-template #treeNodeTemplate let-node>
        <a
          attr.aria-haspopup
          mheStopPropagation
          rdrxBonsaiNodeSelect
          href="javascript:void(0)"
          class="rdrx-node-content ahe-ui-link show-locations-view"
          [attr.data-automation-id]="'topics-tree-child-' + node.id"
          tabindex="-1"
          [rdrxTopicsActiveNode]="node.id === (activeTopicId$ | async)"
          [rdrxBonsaiNodeSelectKeyboard]="!node.collapsible"
          (click)="showLocationsView(node)"
        >
          {{ node.title }}
        </a>
        <button
          data-automation-id="topics-tree-practice-button"
          *ngIf="node.type === 'TOPIC_CATEGORY' && node.assessments.length"
          aria-labelledby="{{ node.title }}"
          mheStopPropagation
          class="btn btn-secondary"
          (click)="handleNodeClick(node)"
          translate
        >
          contents.topics_practice
        </button>
      </ng-template>
      <ng-template #emptyTemplate>
        <div class="topic-alert">
          <mhe-alert
            id="expanded-topics-tree-error"
            [smallAlert]="true"
            [type]="AlertType.Error"
            [closable]="false"
            data-automation-id="topics-topic-alert"
          >
            {{ "contents.topics_menu_alert" | translate }}
          </mhe-alert>
        </div>
      </ng-template>
    </ngx-bonsai>
  </ng-template>
</ng-template>
